import { isConnect } from 'utils/branding.util';

export const config = {
  firebase: {
    firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    firebaseRealDataBase: process.env.REACT_APP_FIREBASE_REAL_TIME_DB,
    firebaseStorageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    firebaseMessagingSenderId:
      process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID,
  },
  merakiApi: {
    url: process.env.REACT_APP_MERAKI_API,
    token: process.env.REACT_APP_MERAKI_TOKEN,
  },
  merakiCms: {
    url: process.env.REACT_APP_MERAKI_CMS,
  },
  salesApi: {
    url: process.env.REACT_APP_API_SALES_URL,
  },
  connectWeb: {
    pr: isConnect ? 'https://connect.pr' : 'https://app.consoda.com/login',
    cr: 'https://connect.cr',
    pty: 'https://www.connect.com.pa/',
    co: 'https://connect.com.co',
    mx: 'https://connect.pr',
  },
  accounts: {
    pr: {
      name: 'Connect Asistance Puerto Rico',
      id: process.env.REACT_APP_ACCOUNT_ID_PR,
    },
    co: {
      name: 'Connect Asistance Colombia',
      id: process.env.REACT_APP_ACCOUNT_ID_CO,
    },
    cr: {
      name: 'Connect Asistance CR',
      id: process.env.REACT_APP_ACCOUNT_ID_CR,
    },
    pty: {
      name: 'Connect Asistance Panama',
      id: process.env.REACT_APP_ACCOUNT_ID_PTY,
    },
    mx: {
      name: 'Connect Asistance México',
      id: process.env.REACT_APP_ACCOUNT_ID_MX,
    },
  },
  recaptchaKey: process.env.REACT_APP_RECAPTCHA_KEY,
  stripe: {
    pr: process.env.REACT_APP_PK_STRIPE,
    cr: process.env.REACT_APP_PK_STRIPE_CR,
    co: process.env.REACT_APP_PK_STRIPE_CO,
  },
  dlocal: {
    cr: process.env.REACT_APP_DLOCAL_SMART_FIELDS_KEY_CR as string,
    co: process.env.REACT_APP_DLOCAL_SMART_FIELDS_KEY_CO as string,
  },
  default_plans: {
    pr: process.env.REACT_APP_DEFAULT_PLANS_ID_PR,
    cr: process.env.REACT_APP_DEFAULT_PLANS_ID_CR,
    pa: process.env.REACT_APP_DEFAULT_PLANS_ID_PA,
    co: process.env.REACT_APP_DEFAULT_PLANS_ID_CO,
    free: process.env.REACT_APP_PLAN_FREEMIUN_ID,
    addon: process.env.REACT_APP_PLAN_ADDON_ID,
  },
  defaultBranch: process.env.REACT_APP_DEFAULT_BRANCH,
  timer: {
    timeOfInactivity: process.env.REACT_APP_TIME_OF_INACTIVITY,
    timeOfSession: process.env.REACT_APP_TIME_OF_SESSION,
  },
  aesKey: process.env.REACT_APP_KEY_AES,
  ruedazUrl: process.env.REACT_APP_RUEDAZ_URL as string,
  zapier: {
    webhookRuedaz: process.env.REACT_APP_ZAPIER_WEBHOOK_URL as string,
  },
  soda: {
    sodaUrl: process.env.REACT_APP_SODA_URL,
    sodaVercelUrl: process.env.REACT_APP_SODA_VERCEL_URL,
    // Solo STG (CB-183): sufijo de los previews de Amplify del front Soda, ej. `.d1g0bdr9t7wyj2.amplifyapp.com`. Vacío en prod/dev.
    sodaPreviewHostSuffix: process.env.REACT_APP_SODA_PREVIEW_HOST_SUFFIX,
  },
};
